var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "使用和许可条款（“条款”）",
        "append-to-body": true,
        width: "783px",
        top: "100px",
        visible: _vm.isVisible,
        "close-on-click-modal": false,
        "close-on-press-escape": false
      },
      on: {
        "update:visible": function($event) {
          _vm.isVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "content", staticStyle: { "font-size": "12px" } },
        [
          _c("section", [
            _c(
              "p",
              { staticStyle: { margin: "1em 0", "line-height": "1.5em" } },
              [
                _c(
                  "span",
                  { staticStyle: { "text-decoration": "underline" } },
                  [_vm._v("门户和门户上的服务。")]
                ),
                _vm._v("这些使用和许可条款规定客户对以下内容的使用：")
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { margin: "1em 0", "line-height": "1.5em" } },
              [
                _vm._v("\n        -\n        "),
                _c(
                  "p",
                  {
                    staticStyle: {
                      display: "inline-block",
                      width: "calc(100% - 40px)",
                      "vertical-align": "top",
                      "margin-left": "10px"
                    }
                  },
                  [
                    _vm._v(
                      "巴斯夫的D’litE3-X（“门户”），包括所有网页、域名、子域名和子部件；和"
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { margin: "1em 0", "line-height": "1.5em" } },
              [
                _vm._v("\n        -\n        "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "inline-block",
                      width: "calc(100% - 40px)",
                      "vertical-align": "top",
                      "margin-left": "10px"
                    }
                  },
                  [
                    _vm._v(
                      "\n          门户上或通过门户提供的或巴斯夫以其他方式在门户上或通过门户提供的与门户上列出的事件和服务相关的所有服务（“服务”），以及门户上或通过门户提供的或巴斯夫以其他方式连同门户一起提供的任何和所有软件，包括但不限于巴斯夫的移动应用程序（“软件”）。本软件被视为服务的一部分。\n        "
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "p",
              { staticStyle: { margin: "1em 0", "line-height": "1.5em" } },
              [
                _c(
                  "span",
                  { staticStyle: { "text-decoration": "underline" } },
                  [_vm._v("客户信息的收集、使用和披露。")]
                ),
                _vm._v(
                  "使用巴斯夫的门户和门户的服务客户承认并同意，其向巴斯夫提供或使巴斯夫可获得的或巴斯夫和/或其关联方拥有的与客户有关的信息（包括但不限于国家，地形、个人护理产品使用和实践、个人护理和个人护理产品的分配、最终客户和个人数据）（统称为“信息”）可由巴斯夫对于信息的收集、使用、存储、合并、处理、披露、转移和分享请参照“门户和门户的服务数据隐私声明”。\n      "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("section", [
            _c(
              "p",
              { staticStyle: { margin: "1em 0", "line-height": "1.5em" } },
              [_vm._v("术语定义如下：")]
            ),
            _vm._v(" "),
            _c(
              "p",
              { staticStyle: { margin: "1em 0", "line-height": "1.5em" } },
              [
                _c("strong", [_vm._v("“关联方”")]),
                _vm._v(
                  "指除巴斯夫（地址：德意志联邦共和国路德维希港，邮编67056）以外的由巴斯夫股份公司直接或间接拥有、持有或控制至少50%的股本或投票权的公司/实体，或由其通过股权、董事职位、管理、利益共同体或合同有权影响该公司、合伙企业或其他组织形式的管理和政策的公司/实体，包括巴斯夫股份公司及其继承人和受让人。"
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "p",
              { staticStyle: { margin: "1em 0", "line-height": "1.5em" } },
              [
                _c("strong", [_vm._v("“巴斯夫”")]),
                _vm._v(
                  "指在客户所在国家/地区运营和/或向客户提供门户的巴斯夫法人实体。"
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "p",
              { staticStyle: { margin: "1em 0", "line-height": "1.5em" } },
              [
                _c("strong", [_vm._v("“客户”")]),
                _vm._v(
                  "指通过任何方式联系巴斯夫或其关联方请求其提供巴斯夫产品和服务，或与巴斯夫或其关联方签订了由巴斯夫或其关联方提供货物和服务的合同的个人或组织（以及该组织的授权代表）。"
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "p",
              { staticStyle: { margin: "1em 0", "line-height": "1.5em" } },
              [
                _c("strong", [_vm._v("“个人数据”")]),
                _vm._v(
                  "指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。"
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "p",
              { staticStyle: { margin: "1em 0", "line-height": "1.5em" } },
              [
                _vm._v(
                  "在符合“门户和门户的服务数据隐私声明”的基础上，巴斯夫可以将信息分享和披露给以下各方："
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticStyle: { "line-height": "1.5em" } }, [
              _c(
                "span",
                { staticStyle: { display: "inline-block", width: "10px" } },
                [_vm._v("(i)")]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    display: "inline-block",
                    width: "calc(100% - 40px)",
                    "vertical-align": "top",
                    "margin-left": "10px"
                  }
                },
                [
                  _vm._v(
                    "在客户所在国家/地区或海外的巴斯夫的关联方、巴斯夫或其关联方的董事、高级职员、雇员、专业顾问、审计人员、\n          合资伙伴、代理商、代表，以及向巴斯夫和/或其关联方提供服务（包括数据存储、收集、使用和信息传输）的第三方，\n          相关信息仅需按照“需要知道”的基础提供；"
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticStyle: { "line-height": "1.5em" } }, [
              _c(
                "span",
                { staticStyle: { display: "inline-block", width: "10px" } },
                [_vm._v("(ii)")]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    display: "inline-block",
                    width: "calc(100% - 40px)",
                    "vertical-align": "top",
                    "margin-left": "10px"
                  }
                },
                [_vm._v("相关司法管辖区内的任何司法、政府、监管或监督机构；")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticStyle: { "line-height": "1.5em" } }, [
              _c(
                "span",
                { staticStyle: { display: "inline-block", width: "10px" } },
                [_vm._v("(iii)")]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    display: "inline-block",
                    width: "calc(100% - 40px)",
                    "vertical-align": "top",
                    "margin-left": "10px"
                  }
                },
                [
                  _vm._v(
                    "巴斯夫在相关合同或协议下的权利和/或义务的任何潜在承让方或受让方，或与巴斯夫和/或其一个或多个关联方的任何\n          销售、并购、兼并或合并有关的任何潜在承让方或受让方；"
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", [
              _c(
                "span",
                { staticStyle: { display: "inline-block", width: "10px" } },
                [_vm._v("(iv)")]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    display: "inline-block",
                    width: "calc(100% - 40px)",
                    "vertical-align": "top",
                    "margin-left": "10px"
                  }
                },
                [
                  _vm._v(
                    "巴斯夫聘用的和/或合资计划、服务协议、交叉销售协议、诚信或促销计划或任何共同或联合开展的项目指定的与营销\n          计划相关的代表、代理商或服务提供商。"
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "p",
              { staticStyle: { margin: "1em 0", "line-height": "1.5em" } },
              [
                _vm._v(
                  "根据所有相关司法管辖区适用的保密和数据隐私法律规定，上述内容构成获得客户的明示许可。如果适用的数据或其他法律对某些相关信息提出保密要求，但允许一方通过书面许可放弃此类要求，此处提供的明示许可应构成此类适用法律所述的客户的书面许可。客户和巴斯夫之间的任何信息保密协议应继续得到遵守，前提是该协议与本条款下对信息披露的许可不相抵触。即使您与巴斯夫的关系（例如合同关系）已经以任何方式终止或变更，上述目的也可在一段合理的时间内继续适用。撤回此类请求的任何请求应通过书面函件或通知，或通过电子邮件发送给为客户所分配的指定的巴斯夫门户联系人，以供其考虑。"
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("section", [
            _c(
              "p",
              { staticStyle: { margin: "1em 0", "line-height": "1.5em" } },
              [
                _c(
                  "span",
                  { staticStyle: { "text-decoration": "underline" } },
                  [_vm._v("门户访问和服务获取的安全性。")]
                ),
                _vm._v(
                  "为访问门户和获取服务而创建的客户用户名和密码仅是客户及其授权代表和用户的个人信息。客户仍然有责任对其门户的用户名和密码保密，并且不向任何第三方透露。未经巴斯夫事先书面许可，客户还同意不允许任何其他第三方使用其门户用户名和密码，或以其他方式访问门户或获取服务。客户同意：\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticStyle: { "line-height": "1.5em" } }, [
              _c(
                "span",
                { staticStyle: { display: "inline-block", width: "10px" } },
                [_vm._v("(a)")]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    display: "inline-block",
                    width: "calc(100% - 40px)",
                    "vertical-align": "top",
                    "margin-left": "10px"
                  }
                },
                [
                  _vm._v(
                    "承诺将严格管理门户试用帐号、密码,获取的数据，不随意散布，并监督所属人员的使用情况。若出现故意泄露帐号的情况，客户将被视为违约，巴斯夫有权立即停止相关帐号的使用，并可依法追究客户的法律责任；"
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticStyle: { "line-height": "1.5em" } }, [
              _c(
                "span",
                { staticStyle: { display: "inline-block", width: "10px" } },
                [_vm._v("(b)")]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    display: "inline-block",
                    width: "calc(100% - 40px)",
                    "vertical-align": "top",
                    "margin-left": "10px"
                  }
                },
                [_vm._v("确保其在每次会话结束时退出或注销门户网站；")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticStyle: { "line-height": "1.5em" } }, [
              _c(
                "span",
                { staticStyle: { display: "inline-block", width: "10px" } },
                [_vm._v("(c)")]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    display: "inline-block",
                    width: "calc(100% - 40px)",
                    "vertical-align": "top",
                    "margin-left": "10px"
                  }
                },
                [
                  _vm._v(
                    "仅限于最终用户以合理的方式使用及用于完成本职工作 （了解消费者和市场信息，了解巴斯夫专有配方及产品，以及新产品上市，研发）之目的；"
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticStyle: { "line-height": "1.5em" } }, [
              _c(
                "span",
                { staticStyle: { display: "inline-block", width: "10px" } },
                [_vm._v("(d)")]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    display: "inline-block",
                    width: "calc(100% - 40px)",
                    "vertical-align": "top",
                    "margin-left": "10px"
                  }
                },
                [
                  _vm._v(
                    "不应进行任何破坏或试图破坏网络安全的行为（包括但不限于钓鱼，黑客，网络诈骗，网站或空间中含有或涉嫌散播：病毒、木马、恶意代码，及通过虚拟服务器对其他网站、服务器进行涉嫌攻击行为如扫描、嗅探、ARP欺骗、DDOS等）；"
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticStyle: { "line-height": "1.5em" } }, [
              _c(
                "span",
                { staticStyle: { display: "inline-block", width: "10px" } },
                [_vm._v("(e)")]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    display: "inline-block",
                    width: "calc(100% - 40px)",
                    "vertical-align": "top",
                    "margin-left": "10px"
                  }
                },
                [
                  _vm._v(
                    "不应进行任何改变或试图改变提供的系统配置或破坏系统安全及网络安全的行为；"
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticStyle: { "line-height": "1.5em" } }, [
              _c(
                "span",
                { staticStyle: { display: "inline-block", width: "10px" } },
                [_vm._v("(f)")]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    display: "inline-block",
                    width: "calc(100% - 40px)",
                    "vertical-align": "top",
                    "margin-left": "10px"
                  }
                },
                [
                  _vm._v(
                    "不应修改、翻译、改编、出租、转许可、在信息网络上传播或转让巴斯夫提供的软件或服务，也不得逆向工程、反编译或试图以其他方式发现巴斯夫提供的软件的源代码；"
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticStyle: { "line-height": "1.5em" } }, [
              _c(
                "span",
                { staticStyle: { display: "inline-block", width: "10px" } },
                [_vm._v("(g)")]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    display: "inline-block",
                    width: "calc(100% - 40px)",
                    "vertical-align": "top",
                    "margin-left": "10px"
                  }
                },
                [
                  _vm._v(
                    "不应以任何将会违反国家、地方法律法规、行业惯例和社会公共道德，及影响、损害或可能影响、损害巴斯夫利益的方式或目的使用门户和门户的服务"
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "p",
              { staticStyle: { margin: "1em 0", "line-height": "1.5em" } },
              [
                _vm._v(
                  "巴斯夫不对因客户不遵守这些使用条款或由客户导致或可归因于客户的任何未经授权访问或使用门户而导致的任何损失和责任负责。"
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("section", [
            _c(
              "p",
              { staticStyle: { margin: "1em 0", "line-height": "1.5em" } },
              [
                _c(
                  "span",
                  { staticStyle: { "text-decoration": "underline" } },
                  [_vm._v("信息的准确性")]
                ),
                _vm._v(
                  " 巴斯夫通常信赖客户或客户授权代表提供的信息。客户同意提供与门户和服务相关的真实、准确、当前和完整的客户信息。为确保信息是当前、完整和准确的，客户需要通过书面通知（函件或电子邮件）或巴斯夫指定或同意的其他方式就其对门户的使用或与此有关的目的更新其信息，该书面通知需发送给指派给客户的巴斯夫指定联系人。如果任何提供的信息或巴斯夫有合理的理由怀疑任何信息不真实、不准确、过时或不完整，巴斯夫有权自行决定暂停或终止客户对门户和/或服务（或其任何部分）的使用"
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("section", [
            _c(
              "p",
              { staticStyle: { margin: "1em 0", "line-height": "1.5em" } },
              [
                _c(
                  "span",
                  { staticStyle: { "text-decoration": "underline" } },
                  [_vm._v("门户管理：")]
                ),
                _vm._v("此外，在不损害其法律权利的情况下，巴斯夫保留以下权利：")
              ]
            ),
            _vm._v(" "),
            _c("div", { staticStyle: { "line-height": "1.5em" } }, [
              _c(
                "span",
                { staticStyle: { display: "inline-block", width: "10px" } },
                [_vm._v("a)")]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    display: "inline-block",
                    width: "calc(100% - 40px)",
                    "vertical-align": "top",
                    "margin-left": "10px"
                  }
                },
                [
                  _vm._v(
                    "出于其自行认为必要或方便的任何原因，拒绝、暂停、修改或终止客户在任何时间（或永久）访问和/或使用门户或服务或其任何部分；"
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticStyle: { "line-height": "1.5em" } }, [
              _c(
                "span",
                { staticStyle: { display: "inline-block", width: "10px" } },
                [_vm._v("b)")]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    display: "inline-block",
                    width: "calc(100% - 40px)",
                    "vertical-align": "top",
                    "margin-left": "10px"
                  }
                },
                [
                  _vm._v(
                    "拒绝和/或要求客户使用或更改其用户名，前提是其用户名误导、欺骗、混淆、侵犯任何知识产权、具有冒犯性、威胁性或在巴斯夫看来令人反感的。"
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticStyle: { "line-height": "1.5em" } }, [
              _c(
                "span",
                { staticStyle: { display: "inline-block", width: "10px" } },
                [_vm._v("c)")]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    display: "inline-block",
                    width: "calc(100% - 40px)",
                    "vertical-align": "top",
                    "margin-left": "10px"
                  }
                },
                [
                  _vm._v(
                    "保留随时修改、取消、增强门户或服务的一项或多项功能或全部服务的权利，如修改或增强功能等，巴斯夫有权要求客户使用最新更新的版本；届时，巴斯夫将以提前通过在App内合适版面发布公告或发送站内通知等方式通知客户；"
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticStyle: { "line-height": "1.5em" } }, [
              _c(
                "span",
                { staticStyle: { display: "inline-block", width: "10px" } },
                [_vm._v("d)")]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    display: "inline-block",
                    width: "calc(100% - 40px)",
                    "vertical-align": "top",
                    "margin-left": "10px"
                  }
                },
                [
                  _vm._v(
                    "推行巴斯夫及其关联方认为客户可能感兴趣或对客户有用的营销、销售、促销、广告和业务举措（“营销举措”），以及制定、传播、分发和发送与巴斯夫和/或其关联公司的产品、服务、活动、成员资格或奖励计划以及其他促销、计划和优惠相关的营销举措信息、材料、文件或手册。"
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticStyle: { "line-height": "1.5em" } }, [
              _c(
                "span",
                { staticStyle: { display: "inline-block", width: "10px" } },
                [_vm._v("e)")]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    display: "inline-block",
                    width: "calc(100% - 40px)",
                    "vertical-align": "top",
                    "margin-left": "10px"
                  }
                },
                [
                  _vm._v(
                    "不排除日后对使用门户或服务收取费用的可能；如客户仍使用门户或服务，应按届时有效的收费政策付费并应遵守届时巴斯夫公布的有效的服务条款。如在收费后，客户拒绝支付服务费，巴斯夫有权不再向客户提供服务。"
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticStyle: { "line-height": "1.5em" } }, [
              _c(
                "span",
                { staticStyle: { display: "inline-block", width: "10px" } },
                [_vm._v("f)")]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    display: "inline-block",
                    width: "calc(100% - 40px)",
                    "vertical-align": "top",
                    "margin-left": "10px"
                  }
                },
                [
                  _vm._v(
                    "如客户有任何违反本服务条款的情形，为遵守国家网络安全相关法律法规的要求，并防止因病毒、入侵或攻击对门户的使用造成影响，巴斯夫会采取必要安全措施，对网络访问进行安全管理。如发现由客户方原因导致的网络安全事件，巴斯夫除有权随时中断或终止客户使用该服务而无须通知客户；如给巴斯夫造成损失的，巴斯夫有权要求客户赔偿损失。"
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "p",
              { staticStyle: { margin: "1em 0", "line-height": "1.5em" } },
              [_vm._v("巴斯夫保留所有未明确授予的权利。")]
            )
          ]),
          _vm._v(" "),
          _c("section", [
            _c(
              "p",
              {
                staticStyle: {
                  margin: "1em 0",
                  "line-height": "1.5em",
                  "text-decoration": "underline"
                }
              },
              [_vm._v("知识产权：")]
            ),
            _vm._v(" "),
            _c("div", { staticStyle: { "line-height": "1.5em" } }, [
              _c(
                "span",
                { staticStyle: { display: "inline-block", width: "10px" } },
                [_vm._v("(a)")]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    display: "inline-block",
                    width: "calc(100% - 40px)",
                    "vertical-align": "top",
                    "margin-left": "10px"
                  }
                },
                [
                  _vm._v(
                    "除了客户可能选择投放在门户和软件中的所有权仍属于客户的内容之外，巴斯夫和/或其许可方拥有门户和软件中包含的所有知识产权和资料权利（包括但不限于版权、商标或专利权保护），并且保留所有此类权利；"
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticStyle: { "line-height": "1.5em" } }, [
              _c(
                "span",
                { staticStyle: { display: "inline-block", width: "10px" } },
                [_vm._v("(b)")]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    display: "inline-block",
                    width: "calc(100% - 40px)",
                    "vertical-align": "top",
                    "margin-left": "10px"
                  }
                },
                [
                  _vm._v(
                    "应明确禁止未经授权下载，复制，传输，发布，存储或以其他方式使用门户和软件上包含的此类资料，此类行为违反著作权法、商标法或任何其他知识产权法律；"
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticStyle: { "line-height": "1.5em" } }, [
              _c(
                "span",
                { staticStyle: { display: "inline-block", width: "10px" } },
                [_vm._v("(c)")]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    display: "inline-block",
                    width: "calc(100% - 40px)",
                    "vertical-align": "top",
                    "margin-left": "10px"
                  }
                },
                [
                  _vm._v(
                    "客户仅被授予出于查看门户和软件中包含的资料的目的有限的许可，并应遵守本条款的有关规定。"
                  )
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("section", [
            _c(
              "p",
              { staticStyle: { margin: "1em 0", "line-height": "1.5em" } },
              [
                _c(
                  "span",
                  { staticStyle: { "text-decoration": "underline" } },
                  [_vm._v("条款的效力：")]
                ),
                _vm._v(
                  "这些条款与适用于巴斯夫收集、存储、使用、转移和披露客户个人数据或其他信息的任何其他通知、合同条款和许可条款一起适用，除非任何此类通知或含有此类通知条款的文件中另有说明。巴斯夫可能会不时修订这些条款。为了确定是否进行了任何修订，客户可以查阅这些条款的最后更新日期。客户继续使用门户或巴斯夫在门户上或与门户一起提供的服务，即表示客户认可并接受此类变更。"
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "p",
              { staticStyle: { margin: "1em 0", "line-height": "1.5em" } },
              [_vm._v("最后更新日期： [ 2020年6月22日 ]")]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          staticStyle: { "text-align": "center" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  _vm.isVisible = false
                }
              }
            },
            [_vm._v("确 定")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-56ec28de", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56ec28de","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/agreement/Legalcn.vue
// module id = null
// module chunks = 